module.exports = __webpack_public_path__ + "dan-root_resume.pdf";